<div class="header">
  <div class="left">
    <a href="#"><img src="/assets/images/generico/logo.png" class="logo" /></a>
  </div>

  <div class="right">
    <!-- Si hay sesión -->
    <ng-container *ngIf="identity;">
      <span class="user-name">
        {{ identity?.nombres }} {{ identity?.apellidoP }} {{ identity?.apellidoM }}
      </span>
      <button mat-button [matMenuTriggerFor]="menu">
        <mat-icon class="icon" matBadgeColor="warn">person</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="openPerfil()">
          <mat-icon>person</mat-icon> Mi perfil
        </button>
        <button mat-menu-item (click)="logout()">
          <mat-icon>exit_to_app</mat-icon> Cerrar Sesión
        </button>
      </mat-menu>
    </ng-container>

  </div>
</div>




<!-- <div>
  <img src="/assets/images/generico/bnr3.png" class="bnr1">
</div>
 -->
<div class="title1"> Servicios SMARTDOM</div>


<div class="allContent">
  <div class="card-container">
    <ng-container *ngFor="let tramite of servicios">
      <div class="card" *ngIf="tramite.active" (click)="sign(tramite.active, tramite.url)"
        [matTooltip]="tramite.description">
        <div class="card-content">
          <a class="img-card">
            <img src="{{tramite.img}}" />
          </a>
          <h4 class="card-title">
            {{ tramite.name }}
          </h4>
        </div>
        <!--  <div class="card-read-more">
          <a class="button">Ir al trámite</a>
        </div> -->
      </div>

      <div class="card" *ngIf="!tramite.active" [ngClass]="{'disabled': true}">
        <div class="card-content">
          <a class="img-card">
            <img src="{{tramite.img}}" />
          </a>
          <h4 class="card-title">
            {{ tramite.name }}
          </h4>
          <p>
            {{ tramite.description }}
          </p>
        </div>

      </div>
    </ng-container>
  </div>

  <div class="section" *ngIf="ifNotServicios">
    <div class="container">
      <div class="section-header">
        <div class="title">
          <h1>Servicios no encontrados</h1>
        </div>
      </div>

      <div>
        <img src="/assets/images/generico/sorry.png" alt="Image not available" (error)="handleImageError(card)"
          style=" max-width: 100%; max-height: 150px;">
        <h4><b> Lo sentimos, en estos momentos no están disponibles los servicios solicitados.</b> </h4>
        <h4><b> Por favor, intente más tarde.</b> </h4>
      </div>
    </div>
  </div>
</div>


<section class="ftr">
  <!-- <div class="left">
    <div class="brand-info">
      <a href="https://www.smartdom.cl/" target="_blank" style="    align-items: center;
      display: flex;">
        <img src="/assets/images/generico/smartdomlogo-sin2.png" style="height: 12vh;padding-bottom: 20px;">
        <span class="brand-name" style="color: #CD0216;">smart</span>
        <span class="brand-name" style=" color: #20619E;">DOM</span>
      </a>
      <a href="" style="padding-left: 20px;">Políticas de privacidad</a>
      <a href="" style="padding-left: 20px;">Condiciones de uso</a>
      <a href="" style="padding-left: 20px;" (click)="copyToClipboard('solnet@solnet.cl')">Contacto smartDom</a>
    </div>
  </div> -->
  <div class="center ftr-txt">
    {{footer}}
  </div>
  <div class="right">
   <!--  <div class="brand-info">
      <a [href]="webUrl"><img src="/assets/images/generico/logo.png" style="height: 12vh;padding-bottom: 20px;"></a>
      <a style="padding-left: 20px;" (click)="copyToClipboard('dom@penaflor.cl')">Contacto Dom Peñaflor</a>
    </div> -->
  </div>

</section>


<ng-template #sub_tramitesCert let-dialog>
  <div class="dialog-container">
    <h2>Trámites del servicio</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="subTramite('certificados')">Solicitud de Certificados</button>
      <button mat-raised-button color="primary" (click)="subTramite('seguimiento_certificados')">Seguimiento de
        Certificados</button>
      <button mat-raised-button color="primary" (click)="subTramite('validar-certificado')">Validar Certificado
        Digital</button>
    </div>
  </div>
</ng-template>

<ng-template #sub_tramitesExp let-dialog>
  <div class="dialog-container">
    <h2>Trámites del servicio</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="subTramite('expedientes')">Expedientes en linea</button>
      <button mat-raised-button color="primary" (click)="subTramite('pago-derecho')">Pago Cálculo Derechos</button>
      <button mat-raised-button color="primary" (click)="subTramite('seguimiento-expediente')">Seguimiento
        Expedientes</button>
      <button mat-raised-button color="primary" (click)="subTramite('validar-documento')">Validar Documento</button>
    </div>
  </div>
</ng-template>

<ng-template #sub_tramitesIns let-dialog>
  <div class="dialog-container">
    <h2>Trámites del servicio</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="subTramite('inspeccion')">Ingreso de inspección</button>
    </div>
  </div>
</ng-template>

<ng-template #sub_tramitesTot let-dialog>
  <div class="dialog-container">
    <h2>Trámites del servicio</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="subTramite('totem-busqueda-direccion')">Búsqueda de
        propiedad</button>
    </div>
  </div>
</ng-template>

<!-- Routed view  -->
<router-outlet></router-outlet>